import React from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const AddCard = ({ color, title }) => {
  return (
    <Button className="flex flex-col justify-center h-8.7 w-24.6 items-center bg-white text-primaryPurple group hover:bg-primaryPurple">
      <div className="flex flex-col items-center group-hover:text-white">
        <PlusOutlined style={{ fontSize: "18px" }} />
        <div>{title}</div>
      </div>
    </Button>
  );
};

export default AddCard;
